import {PencilIcon, RepoIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useEffect, useRef} from 'react'

import {LABELS} from './constants/labels'
import {useIssueCreateConfigContext} from './contexts/IssueCreateConfigContext'
import type {RepositoryResult} from './create-issue-dialog-entry-query-types'
import styles from './TemplatePickerButton.module.css'
import {DisplayMode} from './utils/display-mode'
import type {IssueCreatePayload} from './utils/model'

// Fields are gated by `@include(if: $includeTemplates)` in the CreateIssue fragment,
// so they are absent when templates are not included — hence Partial.
export type TemplatePickerButtonFragment = Partial<Pick<RepositoryResult, 'nameWithOwner' | 'hasAnyTemplates'>>

export type TemplatePickerButtonProps = {
  repository: TemplatePickerButtonFragment
  template: IssueCreatePayload | undefined
}

export function TemplatePickerButton({repository, template}: TemplatePickerButtonProps) {
  const {setDisplayMode} = useIssueCreateConfigContext()
  const templateText = template ? template.name : LABELS.blankIssueName
  const templatePickerButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    templatePickerButtonRef.current?.focus()
  }, [])

  if (!repository.hasAnyTemplates) {
    return null
  }

  return (
    <div data-testid="template-picker-button" className={styles.TemplatePickerButtonContainer}>
      <Button
        data-testid="template-picker-button-el"
        onClick={() => setDisplayMode(DisplayMode.TemplatePicker)}
        leadingVisual={RepoIcon}
        trailingVisual={PencilIcon}
        ref={templatePickerButtonRef}
      >
        {repository && (
          <span>
            {templateText} <span className={styles.repositoryConnectorText}>in</span> {repository.nameWithOwner}
          </span>
        )}
        {!repository && <>Select a repository</>}
      </Button>
    </div>
  )
}
